import React from "react";
import { NavLink } from "react-router-dom";
import { ReactComponent as Error } from "../helper/svgicon/Project/Error404.svg";
import style from "../sass/error.module.scss";
const ErrorElement = () => {
     return (
          <div className={style.error}>
               <Error width={"80%"} height={"80%"} />
               <NavLink to="/">
                    <button className={style.error_btn}> Go To Home</button>
               </NavLink>
          </div>
     );
};
export default ErrorElement;
